import { FC } from 'react';
import { IconLogoTock } from '@tock/icons';
import AppSettings from 'settings/AppSettings';
import env, { PROD_ENV_STRING } from '@tock/shared/utils/env';

export const ClowncarSidebarSiteInfo: FC<React.PropsWithChildren<unknown>> = () => {
  const envName = env.get(AppSettings.API_BASE);
  const buildNo = window.__BUILD_NUMBER__ || '';

  if (envName === PROD_ENV_STRING) {
    return <IconLogoTock className="ClowncarMenu-logo" />;
  }

  return (
    <div className="ClowncarMenu-env">
      {envName.charAt(0).toUpperCase() + envName.slice(1)}{' '}
      {buildNo && (
        <>
          v<small data-testid="front-end-ver">{buildNo}</small>
        </>
      )}
    </div>
  );
};
